import { Box, Divider, Typography, Grid, TextField, CircularProgress, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiClient from '../../utils/apiClient';


const AddEditBankDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { entityId, entityType } = location.state || {};

    const [formData, setFormData] = useState({
        id: "",
        bankName: '',
        accountNumber: '',
        accountHolderName: '',
        ifscCode: '',
        entityType: entityType || '',
        isDeleted: false,
    });

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [validateErrors, setValidateErrors] = useState({});

    // useEffect(() => {
    //     if (bankDetails) {
    //         setFormData({
    //             bankName: bankDetails?.bankName || '',
    //             accountNumber: bankDetails?.accountNumber || '',
    //             accountHolderName: bankDetails?.accountHolderName || '',
    //             ifscCode: bankDetails?.ifscCode || '',
    //             bankBranch: bankDetails?.bankBranch || '',
    //             entityId: bankDetails?.entityId || '',
    //             entityType: bankDetails?.entityType || '',
    //             isDeleted: bankDetails?.isDeleted || false,
    //         });
    //     }
    // }, [bankDetails]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setValidateErrors((prev) => ({ ...prev, [name]: '' }));
        setError('');
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({ ...prev, [name]: checked }));
    };

    const validateForm = () => {
        const errors = {};

        const accountRegex = /^\d{9,18}$/;
        const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;


        if (!formData.bankName?.trim()) {
            errors.bankName = 'Bank name is required';
        }

    
        if (!formData.accountHolderName?.trim()) {
            errors.accountHolderName = 'Account holder name is required';
        }


        if (!accountRegex.test(formData.accountNumber)) {
            errors.accountNumber = 'Enter a valid bank account number (9-18 digits)';
        }

        if (!ifscRegex.test(formData.ifscCode)) {
            errors.ifscCode = 'Enter a valid IFSC code (e.g., HDFC0123456)';
        }
        // if (!formData.entityId?.trim()) {
        //     errors.entityId = 'Entity ID is required';
        // }

        if (!formData.entityType?.trim()) {
            errors.entityType = 'Entity type is required';
        }

        return errors;
    };

    const getBankDetails = async () => {
        try {
            // const response = await axios.get(apiUrl + `/bankdetails/getbankdetailsbyadmin/${entityId}?entityType=${entityType}`,
            //     {
            //         headers: {
            //             'Content-Type': 'application/json'
            //         },
            //     }
            // )
           const response = await apiClient.get(
  `/bankdetails/getbankdetailsbyadmin/${entityId}`,
  {
    params: {
      entityType,
    },
  }
);
            if (response?.data?.status === true) {
                setFormData((prev) => ({
                    ...prev,
                    id: response?.data?.bankDetails?.id || '',
                    bankName: response?.data?.bankDetails?.bankName || '',
                    accountNumber: response?.data?.bankDetails?.accountNumber || '',
                    accountHolderName: response?.data?.bankDetails?.accountHolderName || '',
                    ifscCode: response?.data?.bankDetails?.ifscCode || '',
                    entityType: response?.data?.bankDetails?.entityType || '',
                    // bankBranch: response.data.bankDetails.bankBranch || '',
                }));
            }
        } catch (error) {
            setError(error?.response?.data?.message
                || ' Error occurred while fetching bank details. Please try again.');

        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setValidateErrors(errors);
            return;
        }

        setLoading(true);
        try {
            let response;

if (formData?.id) {
    response = await apiClient.put(
        `/bankdetails/updatebankdetailsbyadmin/${formData?.id}`,
        formData
    );
} else {
    response = await apiClient.post(
        `/bankdetails/addbankdetailsbyadmin/${entityId}`,
        formData
    );
}

            if (response?.data?.status === true) {
                toast.success(response?.data?.message || " Bank details create / update successfully")
                navigate(-1)
            }

        } catch (error) {
            setError(error?.response?.data?.message || 'Something went wrong. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getBankDetails()
    }, [])

    return (
        <>
            <Box sx={{ p: { xs: 2, sm: 2 } }}>
                <Typography variant="h4" fontWeight={400} mb={1}>
                    Bank Details
                </Typography>
                <Divider sx={{ mb: 3 }} />

                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                            <TextField
                                label="Bank Name"
                                name="bankName"
                                size='small'
                                value={formData.bankName}
                                onChange={handleInputChange}
                                fullWidth
                                error={!!validateErrors.bankName}
                                helperText={validateErrors.bankName}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                            <TextField
                                label="Account Number"
                                name="accountNumber"
                                size='small'
                                type='number'
                                value={formData.accountNumber}
                                onChange={handleInputChange}
                                fullWidth
                                error={!!validateErrors.accountNumber}
                                helperText={validateErrors.accountNumber}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                            <TextField
                                label="Account Holder Name"
                                name="accountHolderName"
                                size='small'
                                value={formData.accountHolderName}
                                onChange={handleInputChange}
                                fullWidth
                                error={!!validateErrors.accountHolderName}
                                helperText={validateErrors.accountHolderName}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                            <TextField
                                label="IFSC Code"
                                name="ifscCode"
                                size='small'
                                value={formData.ifscCode}
                                onChange={handleInputChange}
                                fullWidth
                                error={!!validateErrors.ifscCode}
                                helperText={validateErrors.ifscCode}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                            <TextField
                                label="Entity Type"
                                name="entityType"
                                size='small'
                                value={formData.entityType}
                                onChange={handleInputChange}
                                fullWidth
                                error={!!validateErrors.entityType}
                                helperText={validateErrors.entityType}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        {error && (
                            <Grid item size={12}>
                                <Typography color="error">{error}</Typography>
                            </Grid>
                        )}

                        {/* You can add isDeleted checkbox if needed */}

                        <Grid item size={12}>
                            <Box display="flex" justifyContent="end" mt={2} gap={2}>
                                <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
                                    Cancel
                                </Button>
                                <Button type="submit" variant="contained" disabled={loading}>
                                    {loading ? (
                                        <CircularProgress size={24} sx={{ color: '#fff' }} />
                                    ) : (
                                        formData?.id ? 'Update' : 'Create'
                                    )}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </>
    );
};

export default AddEditBankDetails;
